import { render, staticRenderFns } from "./RoleMaster.vue?vue&type=template&id=fbd85644&scoped=true&"
import script from "./RoleMaster.vue?vue&type=script&lang=js&"
export * from "./RoleMaster.vue?vue&type=script&lang=js&"
import style0 from "./RoleMaster.vue?vue&type=style&index=0&id=fbd85644&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd85644",
  null
  
)

export default component.exports